









































import mixins from 'vue-typed-mixins';
import { ResourceLayout, ResourceCategory } from '@/utils/ResourceUtils';
export default mixins().extend({
  name: 'BookshelfLayoutItem',

  props: {
    value: {
      type: Object as () => ResourceLayout,
      required: true,
    },
    parent: {
      type: Object as () => ResourceLayout,
    },
  },

  methods: {
    create(parent?: ResourceLayout) {
      this.$emit('create', parent);
    },

    edit(value: ResourceLayout, parent?: ResourceLayout) {
      this.$emit('edit', value, parent);
    },

    async remove(index: number) {
      const parent = this.value as ResourceCategory;
      if (parent.children) {
        await this.$confirm(
          this.$i18n.tc('validation.confirmation.delete', 1, [
            this.$translate(parent.children[index].title),
          ]),
          async () => {
            parent.children?.splice(index, 1);
          }
        );
      }
    },
  },
});
